import axios from "axios";
import { handleSuccessOne } from "@store/action/GlobalAction";

const API = process.env.REACT_APP_MICRO_SMART_URL;
const VERSION = process.env.REACT_APP_MICRO_SMART_URL_API;
const radio_id = localStorage.getItem("radio_id");

export const getWebsiteStyle = () => (dispatch) => {
  axios.get(`${API}${VERSION}/website/style`).then((response) => {
    dispatch({
      type: "GET_WEBSITE_STYLE",
      data: response.data.data,
    });
  });
};
export const editWebsiteStyle = (data) => (dispatch) => {
  const formData = new FormData();
  formData.append("_method", "PUT");
  formData.append("radio_id", radio_id);
  formData.append("style_text_1", data.style_text_1);
  formData.append("style_text_2", data.style_text_2);
  formData.append("style_color1", data.style_color1);
  formData.append("style_color2", data.style_color2);
  formData.append("logo_position_id", 1);
  formData.append("about_us", data.about_us_en);

  data.bg_type && formData.append("background_type_id", data.bg_type);
  data.layout_mode && formData.append("layout_mode", data.layout_mode);
  data.footer_style && formData.append("style_footer", data.footer_style);
  data.fixed_header && formData.append("fixed_header", data.fixed_header);
  data.fav_icon && formData.append("fav_icon", data.fav_icon);
  data.bg_color && formData.append("style_bg_color", data.bg_color);
  data.logo_en && formData.append("style_logo", data.logo_en);
  data.bg_image && formData.append("bg_image", data.bg_image);
  data.footer_bg && formData.append("footer_bg", data.footer_bg);
  data.apple_icon && formData.append("apple_icon", data.apple_icon);

  axios
    .post(`${API}${VERSION}/setting/update/style`, formData)
    .then((response) => {
      dispatch({
        type: "EDIT_WEBSITE_STYLE_SUCCESS",
        payload: response.data,
      });
      handleSuccessOne(response.data.message);
      dispatch(getWebsiteStyle());
    })
    .catch((err) => {
      if (err.response) {
        dispatch({
          type: "EDIT__WEBSITE_STYLE_FAIL",
          payload: err.response.data.message,
        });
        setTimeout(() => {
          dispatch({
            type: "EDIT__WEBSITE_STYLE_FAIL",
            payload: null,
          });
        }, 3000);
      }
    });
};
